@if (visible$ | async) {
    <fieldset [formGroup]="defectiveComponentReplacementFunctionalElementGroup">
        <ng-container
            *ngrxLet="
                defectiveComponentReplacementFunctionalElement$;
                let defectiveComponentReplacementFunctionalElement
            "
        >
            <div class="row">
                <p
                    class="col-sm-10 col-12"
                    [innerHTML]="defectiveComponentReplacementFunctionalElement.description"
                ></p>
                <span class="text-end col-sm-2 col-12 filter-text">{{ elementTypeLabel$ | async }}</span>
            </div>
            <div class="row">
                <div class="col">
                    @if (defectiveComponentReplacementFunctionalElement.choices) {
                        <pace-forms-choices
                            [choices]="choices$ | async"
                            [formControl]="radioControl"
                        ></pace-forms-choices>
                    }
                </div>
                @if (displayHistoryButton$ | async) {
                    <div class="col-auto d-flex align-items-center">
                        <pace-forms-history-button
                            [uniqueId]="defectiveComponentReplacementFunctionalElement.uniqueId"
                        ></pace-forms-history-button>
                    </div>
                }
            </div>
            @if (displayInputFields$ | async) {
                <div class="row mb-3">
                    <div
                        class="col text-start col-form-label"
                        [innerHTML]="defectiveComponentReplacementFunctionalElement.swapOutComponent.label"
                    ></div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-sm-6">
                        <pace-forms-input-text
                            [id]="defectiveComponentReplacementFunctionalElement.swapOutComponent.matNoXmlId"
                            [label]="defectiveComponentReplacementFunctionalElement.swapOutComponent.matNoLabel"
                            [formControl]="materialSwapOutControl"
                        ></pace-forms-input-text>
                    </div>
                    <div class="col-12 col-sm-6">
                        <pace-forms-input-text
                            [id]="defectiveComponentReplacementFunctionalElement.swapOutComponent.serialNoXmlId"
                            [label]="defectiveComponentReplacementFunctionalElement.swapOutComponent.serialNoLabel"
                            [formControl]="serialSwapOutControl"
                        ></pace-forms-input-text>
                    </div>
                </div>
                <div class="row mb-3">
                    <div
                        class="col text-start col-form-label"
                        [innerHTML]="defectiveComponentReplacementFunctionalElement.swapInComponent.label"
                    ></div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-sm-6">
                        <pace-forms-input-text
                            [id]="defectiveComponentReplacementFunctionalElement.swapInComponent.matNoXmlId"
                            [label]="defectiveComponentReplacementFunctionalElement.swapInComponent.matNoLabel"
                            [formControl]="materialSwapInControl"
                        ></pace-forms-input-text>
                    </div>
                    <div class="col-12 col-sm-6">
                        <pace-forms-input-text
                            [id]="defectiveComponentReplacementFunctionalElement.swapInComponent.serialNoXmlId"
                            [label]="defectiveComponentReplacementFunctionalElement.swapInComponent.serialNoLabel"
                            [formControl]="serialSwapInControl"
                        ></pace-forms-input-text>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <label
                            class="col-form-label"
                            [for]="defectiveComponentReplacementFunctionalElement.repairTimeXmlId"
                            >{{ defectiveComponentReplacementFunctionalElement.repairTimeLabel }}</label
                        >
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button
                                    class="btn stepper-btn"
                                    type="button"
                                    [disabled]="disableRepairTimeButtons$ | async"
                                    (click)="repairTimeDecTrigger$.next()"
                                    [attr.aria-label]="'DECREASE_REPAIR_TIME_DURATION_ARIA_LABEL' | translate"
                                >
                                    -
                                </button>
                            </div>
                            <input
                                type="text"
                                readonly
                                [id]="defectiveComponentReplacementFunctionalElement.repairTimeXmlId"
                                [formControl]="repairTimeControl"
                                (click)="repairTimeClickTrigger$.next()"
                                class="form-control input-md"
                            />
                            <div class="input-group-append">
                                <button
                                    class="btn stepper-btn"
                                    type="button"
                                    [disabled]="disableRepairTimeButtons$ | async"
                                    (click)="repairTimeIncTrigger$.next()"
                                    [attr.aria-label]="'INCREASE_REPAIR_TIME_DURATION_ARIA_LABEL' | translate"
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                @if (showRemarksField$ | async) {
                    <pace-forms-input-text
                        [id]="defectiveComponentReplacementFunctionalElement.xmlId"
                        [label]="defectiveComponentReplacementFunctionalElement.remarksLabel"
                        [formControl]="remarksControl"
                    ></pace-forms-input-text>
                }
            }
        </ng-container>
    </fieldset>
}
